import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "analyseStatistics" }

import { searchFormConfig } from "./config/search.config";
import { ref } from "vue";
import { statisticDay } from '@/service/main/report/analyseStatistics'
import { getDailyCustOption } from './config/chart'
import { useStore } from "@/store";
import {initEmptyParam} from "@/hooks/useInitParam";


export default /*#__PURE__*/_defineComponent({
  __name: 'AnalyseStatistics',
  setup(__props) {

initEmptyParam()
const store = useStore()
const userInfo = store.state.login.userInfo
const getEmp = () => {
  const index = searchFormConfig.formItems.findIndex(
    (item) => item.field === 'empIds'
  )
  if (index > -1) {
    searchFormConfig.formItems.splice(index, 1)
  }
  if (userInfo.isManager == '1') {
    const options = store.state.login.depts
    searchFormConfig.formItems.splice(2, 0, {
      field: 'empIds',
      type: 'cascader',
      label: '员工',
      placeholder: '请选择员工',
      options: options,
      otherOptions: {
        'show-all-levels': false,
        clearable: true,
        props: {
          multiple: true,
          value: 'id',
          label: 'name',
          children: 'emps',
          emitPath: false
        }
      }
    })
  }
}
getEmp()

const getDept = () => {
  const dept = searchFormConfig.formItems.find(
    (item) => item.field === 'deptId'
  )
  const deptData = store.state.login.depts
  dept!.options = deptData.map((item: any) => {
    return { title: item.name, value: item.id }
  })
}
getDept()

const dailyCustOption = ref<any>({})

const getDailyCustStatistics = async (fillDates?: [], deptId?: number, empIds?: [])=> {
  const data = await statisticDay(fillDates, deptId, empIds)
  dailyCustOption.value = getDailyCustOption(data);
}
getDailyCustStatistics();

const handleResetClick = ()=> {
  getDailyCustStatistics()
}
const handleSearchClick = (formdata: any)=> {
  debugger
  getDailyCustStatistics(formdata.fillDates, formdata.deptId, formdata.empIds)
}

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_BaseEchart = _resolveComponent("BaseEchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: handleResetClick,
      onSearchBtnClick: handleSearchClick
    }, null, 8, ["searchFormConfig"]),
    _createVNode(_component_BaseEchart, { options: dailyCustOption.value }, null, 8, ["options"])
  ]))
}
}

})